const promisify = f => function() {

    const args = arguments;
    const callback = args[f.length - 1];

    if (callback) {
        return f.apply(this, Array.from(args));
    } else {
        return new Promise((resolve, reject) => {

            args[f.length - 1] = (err, data) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            };

            args.length = f.length;

            f.apply(this, Array.from(args));

        });
    }

};

const promisifyInverse = f => function() {

    const args = arguments;
    const callback = args[f.length];

    const res = Promise.resolve().then(() => f.apply(this, Array.from(args)));

    if (callback) {
        res.then(
            data => callback(null, data),
            callback
        );
    } else {
        return res;
    }

};

(promisify as any).inverse = promisifyInverse;

export {promisify, promisifyInverse}